<template>
    <div class="module-wa-autosender">
        <SOSlotBase :container-name="'connect-perangkat'">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar page-title="Hubungkan Perangkat" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:content>
                <div class="p-t-16 f-14 f-c-black f-regular">
                    <div class="p-x-20">
                        <div class="header-label">
                            <label class="f-16 m-d-16 f-bold">
                                Mengaktifkan WA perangkat ini:
                            </label>
                        </div>
                        <div class="m-d-16">
                            <div class="d-flex m-d-16">
                                <div class="m-r-4 li-num">1.</div>
                                <div>
                                    Siapkan perangkat kedua (bisa smartphone /laptop /apapun yang bisa membuka
                                    internet).
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="m-r-4 li-num">2.</div>
                                <div>Kirim <span class="f-bold">sebuah tautan</span> ke perangkat kedua:</div>
                            </div>
                        </div>
                        <div class="copy-link m-d-16">
                            <textarea class="text-copy m-d-12" disabled="true" v-model="getShareLink"></textarea>
                            <div class="btn-action">
                                <BtnSalin btn-label="Salin" theme="blue" :left-label="false" :copy-text="getShareLink" />
                                <div class="m-l-12">
                                    <button class="btn-share" @click="doShareLink">
                                        <svg
                                            width="16"
                                            height="17"
                                            viewBox="0 0 16 17"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M12.0002 3.16665C11.2638 3.16665 10.6668 3.7636 10.6668 4.49998C10.6668 4.6903 10.7067 4.87132 10.7786 5.03511C10.7835 5.04371 10.7882 5.05245 10.7928 5.06134C10.8029 5.08097 10.812 5.10086 10.82 5.12095C11.0433 5.54455 11.488 5.83331 12.0002 5.83331C12.7365 5.83331 13.3335 5.23636 13.3335 4.49998C13.3335 3.7636 12.7365 3.16665 12.0002 3.16665ZM9.97359 6.23329C10.4627 6.80459 11.1891 7.16665 12.0002 7.16665C13.4729 7.16665 14.6668 5.97274 14.6668 4.49998C14.6668 3.02722 13.4729 1.83331 12.0002 1.83331C10.5274 1.83331 9.3335 3.02722 9.3335 4.49998C9.3335 4.68339 9.35201 4.86248 9.38728 5.03548L6.02674 6.76667C5.53765 6.19537 4.81119 5.83331 4.00016 5.83331C2.5274 5.83331 1.3335 7.02722 1.3335 8.49998C1.3335 9.97274 2.5274 11.1666 4.00016 11.1666C4.81119 11.1666 5.53765 10.8046 6.02674 10.2333L9.38728 11.9645C9.35201 12.1375 9.3335 12.3166 9.3335 12.5C9.3335 13.9727 10.5274 15.1666 12.0002 15.1666C13.4729 15.1666 14.6668 13.9727 14.6668 12.5C14.6668 11.0272 13.4729 9.83331 12.0002 9.83331C11.1891 9.83331 10.4627 10.1954 9.97359 10.7667L6.61305 9.03548C6.64831 8.86248 6.66683 8.68339 6.66683 8.49998C6.66683 8.31657 6.64831 8.13748 6.61305 7.96448L9.97359 6.23329ZM5.18037 7.87901C5.18836 7.8991 5.1974 7.91899 5.20751 7.93862C5.21209 7.94751 5.21685 7.95625 5.22176 7.96485C5.29362 8.12865 5.3335 8.30966 5.3335 8.49998C5.3335 8.6903 5.29362 8.87131 5.22176 9.03511C5.21685 9.04371 5.21209 9.05245 5.20751 9.06134C5.1974 9.08097 5.18836 9.10086 5.18037 9.12095C4.95703 9.54455 4.51232 9.83331 4.00016 9.83331C3.26378 9.83331 2.66683 9.23636 2.66683 8.49998C2.66683 7.7636 3.26378 7.16665 4.00016 7.16665C4.51232 7.16665 4.95703 7.45541 5.18037 7.87901ZM10.7786 11.9648C10.7835 11.9563 10.7882 11.9475 10.7928 11.9386C10.8029 11.919 10.812 11.8991 10.82 11.879C11.0433 11.4554 11.488 11.1666 12.0002 11.1666C12.7365 11.1666 13.3335 11.7636 13.3335 12.5C13.3335 13.2364 12.7365 13.8333 12.0002 13.8333C11.2638 13.8333 10.6668 13.2364 10.6668 12.5C10.6668 12.3097 10.7067 12.1286 10.7786 11.9648Z"
                                                fill="white"
                                            />
                                        </svg>

                                        <span class="m-l-4">Bagikan</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="m-d-16">
                            <div class="d-flex m-d-16">
                                <div class="m-r-4 li-num">3.</div>
                                <div>
                                    Di perangkat kedua, buka tautan yang telah dikirim. Halaman dengan QR Code akan
                                    tampil. Siapkan untuk di-scan oleh perangkat pertama.
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="m-r-4 li-num">4.</div>
                                <div>Di perangkat pertama, ikuti instruksi:</div>
                            </div>
                        </div>
                        <div class="m-d-16 ">
                            <CoInstruction />
                        </div>
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOButton from "@/so-components/global/ui/SOButton";

import CoInstruction from "../../components/CoInstruction.vue";

import BtnSalin from "../../components/BtnSalin.vue";

import { moduleName } from "../../store/state";

export default {
    name: "WaConnectOnSite",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOButton,
        BtnSalin,
        CoInstruction,
    },
    data() {
        return {
            shareLink: `${window.location.origin}/wa-autosender/connect-perangkat/${this.$route.params.id_device}/web-site`,
        };
    },
    computed: {
        ...mapGetters(moduleName, {
            jwtToken: "jwtToken",
        }),
        getToken() {
            return this.jwtToken().Readonly;
        },
        getShareLink() {
            return `${this.shareLink}?readonly=${this.getToken}`;
        },
    },
    methods: {
        back() {
            this.$router.push({ name: "wa_autosender.connect_perangkat", query: this.$route.query });
        },
        doShareLink() {
            const flutterConfig = JSON.parse(localStorage.getItem('flutterConfig'))
            if (this.isWebview() && flutterConfig.platform !== 'web') {
                this.flutterSendWa('', `Klik tautan berikut untuk scan QR ${this.getShareLink}`)

            } else {
                window.open(`https://wa.me/?text=Klik tautan berikut untuk scan QR ${this.getShareLink}`, '_blank');
            }
        },
    },
};
</script>
<style scoped>
.separator-line {
    margin-left: -20px;
    margin-right: -20px;
}

.li-num {
    min-width: 12px;
}

.copy-link {
    background: #f2f5f7;
    padding: 12px;
    border-radius: 8px;
}

.btn-action {
    display: flex;
    justify-content: center;
}

.text-copy {
    width: 100%;
    padding: 8px 12px;
    color: #6f7287;
    border: 1px solid #c8d0dd;
    background-color: #fff;
    border-radius: 4px;
    resize: none;
}

.btn-share {
    border: 1px solid;
    border-radius: 3px;
    box-sizing: border-box;
    background: #206cff;
    color: white;
    font-size: 12px;
    padding: 2px 8px;
}
</style>
